<template>
  <v-app>
    <v-main>
      <SpinnerLoader v-if="!$store.getters.appIsReady" />
      <transition v-else name="fade-transform" mode="out-in">
        <router-view />
      </transition>
      <IntercomCustomers />
    </v-main>
  </v-app>
</template>

<script>
/*
Actions:
  Use Isready for the absolute objects and loading
  Load store list
  we need to load the storeInfo, because we can send wrong slug
  Wrong slug- redirect Not found page
  create and util to check the store online status
  handleLoad:If come back to the page and there are store info
  **$router.replace for remove the bad slug from the history
  when store info change-check store status util
  load store info automatic load the menu
  load cartdetails and validate if its changing the store, and show the alert to delete the current cart
*/
// import { ConfigGoogleAnanlytic } from "@/utils/google-analytic";
import { ConfigFacebookPixel } from "@/utils/facebook-pixel";
import { ConfigTiktokPixelCode } from "@/utils/tiktok-pixel";
import { ConfigGoogleTagManager } from "@/utils/google-tag-manager";
export default {
  name: "Public",
  data: () => ({
    id: null,
    datas: null,
    pixelCode: "CH8N3CBC77U83I061OI0",
  }),
  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.id = id;
          if (this.$store.getters.appStoresList) {
            this.handleLoad();
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "$store.getters.appStoresList": function () {
      if (this.id) {
        this.handleLoad();
      } else {
        if (this.$route.name === "Home") {
          this.$store.dispatch("app/setIsReady", true);
        }
      }
    },
    "$store.getters.storeInfo": async function () {
      this.$appStoreOnline.check();
    },
  },
  async beforeCreate() {
    const self = this;
    self.$store.dispatch("app/loadStoresList");
    self.$store.dispatch("cart/setLoad");
  },
  mounted() {
    if (this.$store.getters.appInfo.googleAnalyticCode) {
      // ConfigGoogleAnanlytic(this.$store.getters.appInfo.googleAnalyticCode);
      ConfigGoogleTagManager(this.$store.getters.appInfo.googleAnalyticCode);
    }
    if (this.$store.getters.appInfo.facebookPixel) {
      ConfigFacebookPixel(this.$store.getters.appInfo.facebookPixel);
    }
    if (this.$store.getters.appInfo.tiktokPixel) {
      ConfigTiktokPixelCode(this.$store.getters.appInfo.tiktokPixel);
    }
  },
  methods: {
    handleLoad: async function () {
      const self = this;
      self.$store.dispatch("app/setIsReady", false);

      let store = _.find(self.$store.getters.appStoresList, {
        slug: self.id,
      });
      if (store) {
        //check if there are another store-to delete the cart
        if (
          self.$store.getters.cartDetails &&
          self.id != self.$store.getters.cartDetails.items[0].storeSlug
        ) {
          const { value: result } = await Swal.fire({
            title: self.$t("general.change_store"),
            html: self.$t("general.delete_all_cart"),
            icon: "question",
            showCancelButton: true,
            cancelButtonText: self.$t("general.cancel"),
            confirmButtonText: self.$t("general.confirm"),
            allowOutsideClick: false,
          });
          if (result) {
            self.$store.dispatch("cart/deleteDetails");
            self.$store.dispatch("guest/removeSessionId");
            self.$store.dispatch("checkout/setTotal", 0);
          } else {
            self.$router.go(-1);
            setTimeout(() => {
              self.$store.dispatch("app/setIsReady", true);
            }, 500);
            return;
          }
        }

        self.$store.dispatch("storeInfo/setStoreInfo", store);
        self.$store.dispatch("app/setIsReady", true);
      } else {
        self.$router.replace({
          name: "NotFound",
        });
        return;
      }
    },
  },
};
</script>
